import axios from 'axios'
import {api} from '#constants/appUrl'

const token = sessionStorage.getItem('token')
const url = api + 'users'
const headers = {
    'accept': 'application/json',
    'Authorization': 'Bearer ' + token
}

const usersModule = {
    state: {
        users: [],
        currentUser:{}
    },
    mutations: {
        setUsers(state, data) {
            state.users = data
        },
        setCurrentUser(state, data) {
            state.currentUser = data
        },
    },
    actions: {
        fetchAllUsers({commit}, data) {
            return new Promise((resolve, reject) => {
                axios.get(url, {
                    headers: headers,
                    params: data
                }).then((response) => {
                    commit('setUsers', response.data.data)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        fetchUser({commit}, user) {
            return new Promise((resolve, reject) => {
                axios.get( url+ `/${user}`, {
                    headers: headers,
                }).then((response) => {
                    commit('setCurrentUser', response.data.data)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
    }
}

export default usersModule